<template>
	<v-dialog v-model="dialog" persistent max-width="400" scrollable>
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-14 cl-secondary">Pencarian Data</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-col class="px-0 cl-secondary font-size-11 font-weight-500 border-grey">
					<v-row>
						<v-col cols="12">
							<v-text-field hide-details label="Nama Stockist" color="primary" v-model="params.name.value"></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field hide-details label="Kode Stockist" color="primary" v-model="params.code.value"></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field hide-details label="No. Handphone" color="primary" v-model="params.handphone.value"></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-autocomplete label="Provinsi" no-data-text="Tidak ada data" color="primary" hide-details="auto" :items="provinces" item-text="province_name" item-value="province_id" v-model="params.province_id.value" tabindex="13" @change="changeProvince"></v-autocomplete>
						</v-col>
						<v-col cols="12">
							<v-autocomplete label="Kota" no-data-text="Pilih Provinsi Dahulu" color="primary" hide-details="auto" :items="cities" item-text="city_name" item-value="city_id" v-model="params.city_id.value" tabindex="14"></v-autocomplete>
						</v-col>
					</v-row>
				</v-col>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="4">
					<v-btn depressed block color="primary" class="white--text rounded-lg text-capitalize" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="cari">
						<v-icon small v-if="false">mdi-magnify</v-icon>
						<span>Cari</span>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	data () {
		return {
			dialog: false,
			searchDate: false,
			btnLoadingProses: false,
			params: {
				name: {
					type:'string',
					field:'stockist_name',
					value:''
				},
				code: {
					type:'string',
					field:'stockist_code',
					value:''
				},
				handphone: {
					type:'string',
					field:'stockist_mobilephone',
					value:''
				},
				province_id: {
					type:'string',
					field:'stockist_province_id',
					value:''
				},
				city_id: {
					type:'string',
					field:'stockist_city_id',
					value:''
				},
			},
		}
	},
	computed:{
		...mapState('option', ['provinces', 'cities']),
	},
	props: {
		
	},
	methods: {
		...mapActions('option', ['getProvince', 'getCity']),

		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
			this.btnLoadingProses = false
		},
		reset() {
			this.params.name.value = ''
			this.params.code.value = ''
			this.params.handphone.value = ''
			this.params.province_id.value = ''
			this.params.city_id.value = ''
		},
		changeProvince() {
			this.getCity({ province_id: this.params.province_id.value	})
			this.params.city_id.value = ''
		},
		async cari() {
			if ( this.params.name.value || this.params.code.value || this.params.handphone.value || this.params.province_id.value || this.params.city_id.value ) {
				this.btnLoadingProses = await true
				await this.$emit('action', this.params)
			}
		},
	},
	created() {
		this.getProvince()
	}
};
</script>